/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

export const GET_SUMMARY_RESPONSE = {
	totalCO2: {
		label: "Total CO2",
		value: 6829.914,
		unit: "tCO2e"
	},
	targetCO2: {
		kpi: {
			label: "Current FY Target",
			value: 10000,
			unit: "tCO2e"
		},
		percentage: -22
	},
	scopeKpis: [
		{
			label: "Scope 1",
			value: 0,
			unit: "tCO2e"
		},
		{
			label: "Scope 2",
			value: 3706,
			unit: "tCO2e"
		},
		{
			label: "Scope 3",
			value: 3123.914,
			unit: "tCO2e"
		}
	],
	typeKpis: [
		{
			label: "Applications",
			value: 466.737,
			unit: "tCO2e"
		},
		{
			label: "Cloud",
			value: 396.72,
			unit: "tCO2e"
		},
		{
			label: "Hardware assets",
			value: 5964.274,
			unit: "tCO2e"
		},
		{
			label: "AI",
			value: 2.183,
			unit: "tCO2e"
		}
	]
};

export const GET_FORECAST_RESPONSE = {
	TYPE: {
		title: "Forecast for the year",
		series: [
			{
				name: "Applications",
				type: "bar",
				values: [
					{ name: "2025-04T00:00:00Z", value: 50.997 * 0.32, unit: "tCO2e" },
					{ name: "2025-05T00:00:00Z", value: 52.697 * 0.32, unit: "tCO2e" },
					{ name: "2025-06T00:00:00Z", value: 50.997 * 0.32, unit: "tCO2e" },
					{ name: "2025-07T00:00:00Z", value: 52.697 * 0.32, unit: "tCO2e" },
					{ name: "2025-08T00:00:00Z", value: 52.697 * 0.32, unit: "tCO2e" },
					{ name: "2025-09T00:00:00Z", value: 50.997 * 0.32, unit: "tCO2e" },
					{ name: "2025-10T00:00:00Z", value: 52.687 * 0.32, unit: "tCO2e" },
					{ name: "2025-11T00:00:00Z", value: 50.672 * 0.32, unit: "tCO2e" },
					{ name: "2025-12T00:00:00Z", value: 52.29 * 0.32, unit: "tCO2e" }
				]
			},
			{
				name: "Cloud",
				type: "bar",
				values: [
					{ name: "2025-04T00:00:00Z", value: 50.997 * 0.68, unit: "tCO2e" },
					{ name: "2025-05T00:00:00Z", value: 52.697 * 0.68, unit: "tCO2e" },
					{ name: "2025-06T00:00:00Z", value: 50.997 * 0.68, unit: "tCO2e" },
					{ name: "2025-07T00:00:00Z", value: 52.697 * 0.68, unit: "tCO2e" },
					{ name: "2025-08T00:00:00Z", value: 52.697 * 0.68, unit: "tCO2e" },
					{ name: "2025-09T00:00:00Z", value: 50.997 * 0.68, unit: "tCO2e" },
					{ name: "2025-10T00:00:00Z", value: 52.687 * 0.68, unit: "tCO2e" },
					{ name: "2025-11T00:00:00Z", value: 50.672 * 0.68, unit: "tCO2e" },
					{ name: "2025-12T00:00:00Z", value: 52.29 * 0.68, unit: "tCO2e" }
				]
			},
			{
				name: "Hardware assets",
				type: "bar",
				values: [
					{ name: "2025-04T00:00:00Z", value: 738, unit: "tCO2e" },
					{ name: "2025-05T00:00:00Z", value: 740, unit: "tCO2e" },
					{ name: "2025-06T00:00:00Z", value: 735, unit: "tCO2e" },
					{ name: "2025-07T00:00:00Z", value: 724, unit: "tCO2e" },
					{ name: "2025-08T00:00:00Z", value: 702, unit: "tCO2e" },
					{ name: "2025-09T00:00:00Z", value: 691, unit: "tCO2e" },
					{ name: "2025-10T00:00:00Z", value: 688, unit: "tCO2e" },
					{ name: "2025-11T00:00:00Z", value: 673, unit: "tCO2e" },
					{ name: "2025-12T00:00:00Z", value: 670, unit: "tCO2e" }
				]
			},
			{
				name: "AI",
				type: "bar",
				values: [
					{ name: "2025-04T00:00:00Z", value: 0.335, unit: "tCO2e" },
					{ name: "2025-05T00:00:00Z", value: 0.366, unit: "tCO2e" },
					{ name: "2025-06T00:00:00Z", value: 0.277, unit: "tCO2e" },
					{ name: "2025-07T00:00:00Z", value: 0.421, unit: "tCO2e" },
					{ name: "2025-08T00:00:00Z", value: 0.371, unit: "tCO2e" },
					{ name: "2025-09T00:00:00Z", value: 0.413, unit: "tCO2e" },
					{ name: "2025-10T00:00:00Z", value: 0.0, unit: "tCO2e" },
					{ name: "2025-11T00:00:00Z", value: 0.0, unit: "tCO2e" },
					{ name: "2025-12T00:00:00Z", value: 0.0, unit: "tCO2e" }
				]
			},
			{
				name: "Trend line",
				type: "line",
				values: [
					{ name: "2025-04T00:00:00Z", value: 789.606, unit: "tCO2e" },
					{ name: "2025-05T00:00:00Z", value: 793.364, unit: "tCO2e" },
					{ name: "2025-06T00:00:00Z", value: 786.5, unit: "tCO2e" },
					{ name: "2025-07T00:00:00Z", value: 777.464, unit: "tCO2e" },
					{ name: "2025-08T00:00:00Z", value: 755.373, unit: "tCO2e" },
					{ name: "2025-09T00:00:00Z", value: 742.748, unit: "tCO2e" },
					{ name: "2025-10T00:00:00Z", value: 740.687, unit: "tCO2e" },
					{ name: "2025-11T00:00:00Z", value: 723.672, unit: "tCO2e" },
					{ name: "2025-12T00:00:00Z", value: 722.29, unit: "tCO2e" }
				]
			}
		]
	},
	SCOPE: {
		title: "Forecast for the year",
		series: [
			{
				name: "Scope 1",
				type: "bar",
				values: [
					{ name: "2025-04T00:00:00Z", value: 0, unit: "tCO2e" },
					{ name: "2025-05T00:00:00Z", value: 0, unit: "tCO2e" },
					{ name: "2025-06T00:00:00Z", value: 0, unit: "tCO2e" },
					{ name: "2025-07T00:00:00Z", value: 0, unit: "tCO2e" },
					{ name: "2025-08T00:00:00Z", value: 0, unit: "tCO2e" },
					{ name: "2025-09T00:00:00Z", value: 0, unit: "tCO2e" },
					{ name: "2025-10T00:00:00Z", value: 0, unit: "tCO2e" },
					{ name: "2025-11T00:00:00Z", value: 0, unit: "tCO2e" },
					{ name: "2025-12T00:00:00Z", value: 0, unit: "tCO2e" }
				]
			},
			{
				name: "Scope 2",
				type: "bar",
				values: [
					{ name: "2025-04T00:00:00Z", value: 50.997 * 0.15 + 404, unit: "tCO2e" },
					{ name: "2025-05T00:00:00Z", value: 52.697 * 0.15 + 404, unit: "tCO2e" },
					{ name: "2025-06T00:00:00Z", value: 50.997 * 0.15 + 404, unit: "tCO2e" },
					{ name: "2025-07T00:00:00Z", value: 52.697 * 0.15 + 404, unit: "tCO2e" },
					{ name: "2025-08T00:00:00Z", value: 52.697 * 0.15 + 404, unit: "tCO2e" },
					{ name: "2025-09T00:00:00Z", value: 50.997 * 0.15 + 404, unit: "tCO2e" },
					{ name: "2025-10T00:00:00Z", value: 52.687 * 0.15 + 404, unit: "tCO2e" },
					{ name: "2025-11T00:00:00Z", value: 50.672 * 0.15 + 404, unit: "tCO2e" },
					{ name: "2025-12T00:00:00Z", value: 52.29 * 0.15 + 404, unit: "tCO2e" }
				]
			},
			{
				name: "Scope 3",
				type: "bar",
				values: [
					{ name: "2025-04T00:00:00Z", value: 50.997 * 0.85 + 335, unit: "tCO2e" },
					{ name: "2025-05T00:00:00Z", value: 52.697 * 0.85 + 337, unit: "tCO2e" },
					{ name: "2025-06T00:00:00Z", value: 50.997 * 0.85 + 331, unit: "tCO2e" },
					{ name: "2025-07T00:00:00Z", value: 52.697 * 0.85 + 321, unit: "tCO2e" },
					{ name: "2025-08T00:00:00Z", value: 52.697 * 0.85 + 299, unit: "tCO2e" },
					{ name: "2025-09T00:00:00Z", value: 50.997 * 0.85 + 287, unit: "tCO2e" },
					{ name: "2025-10T00:00:00Z", value: 52.687 * 0.85 + 284, unit: "tCO2e" },
					{ name: "2025-11T00:00:00Z", value: 50.672 * 0.85 + 270, unit: "tCO2e" },
					{ name: "2025-12T00:00:00Z", value: 52.29 * 0.85 + 266, unit: "tCO2e" }
				]
			},
			{
				name: "Trend line",
				type: "line",
				values: [
					{ name: "2025-04T00:00:00Z", value: 789.606, unit: "tCO2e" },
					{ name: "2025-05T00:00:00Z", value: 793.364, unit: "tCO2e" },
					{ name: "2025-06T00:00:00Z", value: 786.5, unit: "tCO2e" },
					{ name: "2025-07T00:00:00Z", value: 777.464, unit: "tCO2e" },
					{ name: "2025-08T00:00:00Z", value: 755.373, unit: "tCO2e" },
					{ name: "2025-09T00:00:00Z", value: 742.748, unit: "tCO2e" },
					{ name: "2025-10T00:00:00Z", value: 740.687, unit: "tCO2e" },
					{ name: "2025-11T00:00:00Z", value: 723.672, unit: "tCO2e" },
					{ name: "2025-12T00:00:00Z", value: 722.29, unit: "tCO2e" }
				]
			}
		]
	}
};

export const GET_EMISSIONS_SHARE_RESPONSE = {
	TYPE: {
		title: "Total emissions(%)",
		PieChartSlice: [
			{
				name: "Applications",
				value: 2.2,
				unit: "%"
			},
			{
				name: "Cloud",
				value: 4.6,
				unit: "%"
			},
			{
				name: "Hardware assets",
				value: 93.1,
				unit: "%"
			},
			{
				name: "AI",
				value: 0.1,
				unit: "%"
			}
		]
	},
	SCOPE: {
		title: "Total emissions(%)",
		PieChartSlice: [
			{
				name: "Scope 1",
				value: 0,
				unit: "%"
			},
			{
				name: "Scope 2",
				value: 54.2,
				unit: "%"
			},
			{
				name: "Scope 3",
				value: 45.8,
				unit: "%"
			}
		]
	}
};

export const GET_DETAILS_RESPONSE = {
	TYPE: {
		details: [
			{
				title: "Applications",
				barSeries: [
					{
						name: "Scope 3",
						bars: [
							{
								name: "2025-04T00:00:00Z",
								value: 50.997 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-05T00:00:00Z",
								value: 52.697 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-06T00:00:00Z",
								value: 50.997 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-07T00:00:00Z",
								value: 52.697 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-08T00:00:00Z",
								value: 52.697 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-09T00:00:00Z",
								value: 50.997 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-10T00:00:00Z",
								value: 52.687 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-11T00:00:00Z",
								value: 50.672 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-12T00:00:00Z",
								value: 52.29 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							}
						]
					},
					{
						name: "Scope 2",
						bars: [
							{
								name: "2025-04T00:00:00Z",
								value: 50.997 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-05T00:00:00Z",
								value: 52.697 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-06T00:00:00Z",
								value: 50.997 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-07T00:00:00Z",
								value: 52.697 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-08T00:00:00Z",
								value: 52.697 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-09T00:00:00Z",
								value: 50.997 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-10T00:00:00Z",
								value: 52.687 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-11T00:00:00Z",
								value: 50.672 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-12T00:00:00Z",
								value: 52.29 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							}
						]
					},
					{
						name: "Scope 1",
						bars: [
							{
								name: "2025-04T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-05T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-06T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-07T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-08T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-09T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-10T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-11T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-12T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							}
						]
					}
				]
			},
			{
				title: "Cloud",
				barSeries: [
					{
						name: "Scope 3",
						bars: [
							{
								name: "2025-04T00:00:00Z",
								value: 50.997 * 0.68,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-05T00:00:00Z",
								value: 52.697 * 0.68,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-06T00:00:00Z",
								value: 50.997 * 0.68,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-07T00:00:00Z",
								value: 52.697 * 0.68,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-08T00:00:00Z",
								value: 52.697 * 0.68,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-09T00:00:00Z",
								value: 50.997 * 0.68,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-10T00:00:00Z",
								value: 52.687 * 0.68,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-11T00:00:00Z",
								value: 50.672 * 0.68,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-12T00:00:00Z",
								value: 52.29 * 0.68,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							}
						]
					},
					{
						name: "Scope 2",
						bars: [
							{
								name: "2025-04T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-05T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-06T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-07T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-08T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-09T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-10T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-11T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-12T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							}
						]
					},
					{
						name: "Scope 1",
						bars: [
							{
								name: "2025-04T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-05T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-06T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-07T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-08T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-09T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-10T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-11T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-12T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							}
						]
					}
				]
			},
			{
				title: "Hardware assets",
				barSeries: [
					{
						name: "Scope 3",
						bars: [
							{
								name: "2025-04T00:00:00Z",
								value: 335,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-05T00:00:00Z",
								value: 337,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-06T00:00:00Z",
								value: 331,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-07T00:00:00Z",
								value: 321,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-08T00:00:00Z",
								value: 299,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-09T00:00:00Z",
								value: 287,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-10T00:00:00Z",
								value: 284,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-11T00:00:00Z",
								value: 270,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-12T00:00:00Z",
								value: 266,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							}
						]
					},
					{
						name: "Scope 2",
						bars: [
							{
								name: "2025-04T00:00:00Z",
								value: 404,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-05T00:00:00Z",
								value: 404,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-06T00:00:00Z",
								value: 404,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-07T00:00:00Z",
								value: 404,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-08T00:00:00Z",
								value: 404,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-09T00:00:00Z",
								value: 404,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-10T00:00:00Z",
								value: 404,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-11T00:00:00Z",
								value: 404,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-12T00:00:00Z",
								value: 404,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							}
						]
					},
					{
						name: "Scope 1",
						bars: [
							{
								name: "2025-04T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-05T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-06T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-07T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-08T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-09T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-10T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-11T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-12T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							}
						]
					}
				]
			},
			{
				title: "AI",
				barSeries: [
					{
						name: "Scope 3",
						bars: [
							{
								name: "2025-04T00:00:00Z",
								value: 0.335,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-05T00:00:00Z",
								value: 0.366,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-06T00:00:00Z",
								value: 0.277,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-07T00:00:00Z",
								value: 0.421,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-08T00:00:00Z",
								value: 0.371,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-09T00:00:00Z",
								value: 0.413,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-10T00:00:00Z",
								value: 0.0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-11T00:00:00Z",
								value: 0.0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-12T00:00:00Z",
								value: 0.0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							}
						]
					},
					{
						name: "Scope 2",
						bars: [
							{
								name: "2025-04T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-05T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-06T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-07T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-08T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-09T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-10T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-11T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-12T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							}
						]
					},
					{
						name: "Scope 1",
						bars: [
							{
								name: "2025-04T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-05T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-06T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-07T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-08T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-09T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-10T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-11T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-12T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							}
						]
					}
				]
			}
		]
	},
	SCOPE: {
		details: [
			{
				title: "Scope 1",
				barSeries: [
					{
						name: "Applications",
						bars: [
							{
								name: "2025-04T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-05T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-06T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-07T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-08T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-09T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-10T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-11T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-12T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							}
						]
					},
					{
						name: "Cloud",
						bars: [
							{
								name: "2025-04T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-05T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-06T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-07T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-08T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-09T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-10T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-11T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-12T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							}
						]
					},
					{
						name: "Hardware Assets",
						bars: [
							{
								name: "2025-04T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-05T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-06T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-07T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-08T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-09T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-10T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-11T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-12T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							}
						]
					},
					{
						name: "AI",
						bars: [
							{
								name: "2025-04T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-05T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-06T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-07T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-08T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-09T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-10T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-11T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-12T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							}
						]
					}
				]
			},
			{
				title: "Scope 2",
				barSeries: [
					{
						name: "Applications",
						bars: [
							{
								name: "2025-04T00:00:00Z",
								value: 50.997 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-05T00:00:00Z",
								value: 52.697 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-06T00:00:00Z",
								value: 50.997 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-07T00:00:00Z",
								value: 52.697 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-08T00:00:00Z",
								value: 52.697 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-09T00:00:00Z",
								value: 50.997 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-10T00:00:00Z",
								value: 52.687 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-11T00:00:00Z",
								value: 50.672 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-12T00:00:00Z",
								value: 52.29 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							}
						]
					},
					{
						name: "Cloud",
						bars: [
							{
								name: "2025-04T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-05T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-06T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-07T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-08T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-09T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-10T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-11T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-12T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							}
						]
					},
					{
						name: "Hardware Assets",
						bars: [
							{
								name: "2025-04T00:00:00Z",
								value: 404,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-05T00:00:00Z",
								value: 404,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-06T00:00:00Z",
								value: 404,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-07T00:00:00Z",
								value: 404,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-08T00:00:00Z",
								value: 404,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-09T00:00:00Z",
								value: 404,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-10T00:00:00Z",
								value: 404,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-11T00:00:00Z",
								value: 404,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-12T00:00:00Z",
								value: 404,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							}
						]
					},
					{
						name: "AI",
						bars: [
							{
								name: "2025-04T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-05T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-06T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-07T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-08T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-09T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-10T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-11T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-12T00:00:00Z",
								value: 0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							}
						]
					}
				]
			},
			{
				title: "Scope 3",
				barSeries: [
					{
						name: "Applications",
						bars: [
							{
								name: "2025-04T00:00:00Z",
								value: 50.997 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-05T00:00:00Z",
								value: 52.697 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-06T00:00:00Z",
								value: 50.997 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-07T00:00:00Z",
								value: 52.697 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-08T00:00:00Z",
								value: 52.697 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-09T00:00:00Z",
								value: 50.997 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-10T00:00:00Z",
								value: 52.687 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-11T00:00:00Z",
								value: 50.672 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-12T00:00:00Z",
								value: 52.29 * 0.16,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							}
						]
					},
					{
						name: "Cloud",
						bars: [
							{
								name: "2025-04T00:00:00Z",
								value: 50.997 * 0.68,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-05T00:00:00Z",
								value: 52.697 * 0.68,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-06T00:00:00Z",
								value: 50.997 * 0.68,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-07T00:00:00Z",
								value: 52.697 * 0.68,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-08T00:00:00Z",
								value: 52.697 * 0.68,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-09T00:00:00Z",
								value: 50.997 * 0.68,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-10T00:00:00Z",
								value: 52.687 * 0.68,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-11T00:00:00Z",
								value: 50.672 * 0.68,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-12T00:00:00Z",
								value: 52.29 * 0.68,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							}
						]
					},
					{
						name: "Hardware Assets",
						bars: [
							{
								name: "2025-04T00:00:00Z",
								value: 335,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-05T00:00:00Z",
								value: 337,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-06T00:00:00Z",
								value: 331,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-07T00:00:00Z",
								value: 321,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-08T00:00:00Z",
								value: 299,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-09T00:00:00Z",
								value: 287,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-10T00:00:00Z",
								value: 284,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-11T00:00:00Z",
								value: 270,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-12T00:00:00Z",
								value: 266,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							}
						]
					},
					{
						name: "AI",
						bars: [
							{
								name: "2025-04T00:00:00Z",
								value: 0.335,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-05T00:00:00Z",
								value: 0.366,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-06T00:00:00Z",
								value: 0.277,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-07T00:00:00Z",
								value: 0.421,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-08T00:00:00Z",
								value: 0.371,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-09T00:00:00Z",
								value: 0.413,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-10T00:00:00Z",
								value: 0.0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-11T00:00:00Z",
								value: 0.0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							},
							{
								name: "2025-12T00:00:00Z",
								value: 0.0,
								unit: "tCO2e",
								tenantRegion: true,
								percentageDiff: 10,
								baselineValue: 10
							}
						]
					}
				]
			}
		]
	}
};
